import React, { createContext, useState } from 'react'
import FileInput from '../../components/molecules/FileInput'
import Email from '../../main/FormFields/Email'

import { Spinner } from 'react-bootstrap'
import { Button, Card, CardBody, CardHeader, Col, Form, FormGroup, Row } from 'reactstrap'

import { ToastContainer } from 'react-toastify'
import { notify } from '../../utils/notify'
import { useFileUpload } from '../../hooks'


const EmailContext = createContext()


const HtmlCleanerForm = () => {
  const [files, setFiles] = useState(null)
  const { upload, loading } = useFileUpload()
  const [emails, setEmails] = useState([])


const handleSubmit = async (event) => {
    event.preventDefault()

    if (files == null || emails.length === 0) {
      notify('File o mail mancanti', 'error')
      return
    }

    let formData = new FormData()
    for (let index = 0; index < files.length; index++) {
      formData.append('files', files[index])
    }
    formData.append('mail', emails)

    try {
      await upload('post', 'html-cleaner/', formData, {
        onSuccess: (data) => {
       if (typeof data === 'undefined') {
         notify('Could not retrieve datas.', 'error')
         console.warn('Could not retrieve datas')
       } else {
         notify(data, 'success')
       }
       setEmails([])
       setFiles(null)
     },
      })
    } catch (err) {
      console.error('HTML Cleaner failed:', err)
    }
  }
  return (
    <>
      {loading ? (
        <Spinner animation="grow" />
      ) : (
      <div className="col pb-5">
			<Card className="bg-secondary shadow">
					<CardHeader className="bg-white border-0">
						<Row style={{ marginLeft: "0px" }}>
							<Col md={10}>
								<h1 className="mb-0">Html Cleaner</h1>
							</Col>
						</Row>
					</CardHeader>
        <CardBody>
        <Form onSubmit={handleSubmit} id="idea-form" action="">
          <Row>
            <Col md={6}>
              <FileInput
                  onFileChange={setFiles}
                  accept=".html"
                  multiple={true}
                  required={true}
              />
              <FormGroup style={{marginTop:"1em"}}>
                  <EmailContext.Provider value={{ emails, setEmails }}>
                    <Email context={EmailContext} />
                  </EmailContext.Provider>
                </FormGroup>
            </Col>
          </Row>
          <Row style={{display: "flex", justifyContent: "flex-end", marginRight:"50px"}}>
            <Button color="info" size="lg" onClick={handleSubmit} >Submit Report</Button>
          </Row>
        </Form>
        </CardBody>
			</Card>
			</div>
      )}
      <ToastContainer />
    </>
  )
}

export default HtmlCleanerForm
